import React, { useCallback, useLayoutEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import WranglerApp from '../../submodules/wrangler/apps/wrangler/src/App';
import '../../submodules/wrangler/apps/wrangler/src/App.css';
import '../../submodules/wrangler/apps/wrangler/src/index.css';
import dsaAuthStore from '../../submodules/wrangler/apps/wrangler/src/utils/dsaAuthStore';
import { ensureProtocolsLoaded } from '../../submodules/wrangler/apps/wrangler/src/utils/protocolSource';
import { useAuth } from '../../providers/AuthContext';
import { getAppLogoSrc } from '../../utils/appBranding';
import styles from './Wrangler.module.css';

function Wrangler() {
    const { token, user } = useAuth();
    const queryClient = useQueryClient();

    useLayoutEffect(() => {
        const baseUrl = `${window.location.origin}/dsa`;
        if (token) {
            dsaAuthStore.importHostSession({ token, user, baseUrl });
            ensureProtocolsLoaded().catch(() => {});
        } else {
            dsaAuthStore.clearLocalSession();
        }
    }, [token, user]);

    const handleCatalogChanged = useCallback(() => {
        queryClient.invalidateQueries({ queryKey: ['bdsa-stain'] });
        queryClient.invalidateQueries({ queryKey: ['bdsa-region'] });
        queryClient.invalidateQueries({ queryKey: ['bdsa-block'] });
        queryClient.invalidateQueries({ queryKey: ['bdsa-protocol'] });
    }, [queryClient]);

    return (
        <div className={styles.embed}>
            <WranglerApp
                embedded
                schemaFile="/assets/bdsa-schema.json"
                logoSrc={getAppLogoSrc()}
                onCatalogChanged={handleCatalogChanged}
            />
        </div>
    );
}

export default Wrangler;
